import { useEffect, useRef, useState } from 'react'
import { useClickOutside } from '@winnin/winnin_ui.hooks.use-click-outside'

import type { IChipWithInputModel } from './chip-with-input.types'

export function useChipWithInputModel(onSubmit: (value: string) => void): IChipWithInputModel {
  const [isEditing, setIsEditing] = useState(false)
  const [inputValue, setInputValue] = useState('')
  const inputRef = useRef<HTMLInputElement>(null)
  const wrapperRef = useRef<HTMLButtonElement>(null)

  const { isClickOutside } = useClickOutside(wrapperRef)

  useEffect(() => {
    if (isEditing && inputRef.current) {
      inputRef.current.focus()
    }
  }, [isEditing])

  useEffect(() => {
    if (isClickOutside && isEditing) {
      handleCancel()
    }
  }, [isClickOutside, isEditing])

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && inputValue.trim()) {
      onSubmit(inputValue.trim())
      setInputValue('')
      setIsEditing(false)
    } else if (e.key === 'Escape') {
      handleCancel()
    }
  }

  const handleCancel = () => {
    setInputValue('')
    setIsEditing(false)
  }

  return {
    isEditing,
    inputValue,
    inputRef,
    wrapperRef,
    handleKeyDown,
    handleCancel,
    setIsEditing,
    setInputValue,
  }
}
